import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Layout } from '../Layout';
import { ErrorPage } from '../../../payment/components/ErrorPage';
import DuplicateTabsIcon from '../../icons/DuplicateTabsIcon';

const TabDisconnected = () => {
  const data = useStaticQuery<GatsbyTypes.TabDisconnectedQueryQuery>(graphql`
    query TabDisconnectedQuery {
      markdownRemark(frontmatter: { path: { eq: "tab-disconnected" } }) {
        frontmatter {
          title
          subTitleOne
          subTitleTwo
        }
      }
    }
  `);

  const tabDisconnectedData = data.markdownRemark!.frontmatter!;

  const { title, subTitleOne, subTitleTwo } = tabDisconnectedData;

  return (
    <Layout currentPage="/">
      <ErrorPage
        title={title!}
        text={subTitleOne!}
        subText={subTitleTwo!}
        icon={<DuplicateTabsIcon />}
      />
    </Layout>
  );
};

export default TabDisconnected;
